import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default async function checkSalesAgentCoBroker(
	salesAgentId,
	coBrokerId,
	callback
) {
	firebaseRef
		.ref('/kavtek_coBrokers/' + PROJECT_CODE.projectCode)
		.orderByChild('userId')
		.equalTo(coBrokerId)
		.on('value', (snapshot) => {
			var cobrokerRef = snapshot.val();

			var cobrokerRefKeys = Object.keys(cobrokerRef);

			var cobrokerObj = cobrokerRef[cobrokerRefKeys[0]];

			var actualSalesAgentId = cobrokerObj['assignedSalesAgent'];

			if (salesAgentId === actualSalesAgentId) {
				callback(true);
			}
		});
}
